import {pipelineNameValidators} from './usePipelineNameValidationError.consts'

import useValidationErrorMessage from 'src/components/pages/PipelinesPages/hooks/useValidationErrorMessage'

function usePipelineNameValidationError(name: string) {
  const pipelineNameSpotErrorId = 'pipeline_name'
  const {
    errorMessage: pipelineNameErrorMessage,
    handlerValidationError: handlerPipelineNameValidation,
  } = useValidationErrorMessage(
    {
      value: name,
      validators: pipelineNameValidators,
    },
    pipelineNameSpotErrorId,
  )

  return {
    handlerPipelineNameValidation,
    pipelineNameErrorMessage,
  }
}

export default usePipelineNameValidationError
